import type { RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

import { NotificationsPage } from './NotificationsPage'

export const routes: RouteObject[] = [{ path: '/settings/notifications', element: <NotificationsPage /> }]

export const nav: NavItem[] = [
  { path: '/settings/notifications', label: 'Уведомления', icon: 'alert', mobile: null, order: 30, parent: '/settings' },
]
